import React, { lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
const Services = lazy(() => import("./pages/Services"));
const Nosotros = lazy(() => import("./pages/Nosotros"));
const CaseStudy = lazy(() => import("./pages/CaseStudy"));
const Blog = lazy(() => import("./pages/Blog"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const FAQ = lazy(() => import("./pages/FAQ"));
const Glosario = lazy(() => import("./pages/Glosario"));
const GlossaryTerm = lazy(() => import("./pages/GlossaryTerm"));
const Descargables = lazy(() => import("./pages/Descargables"));
const CountryLanding = lazy(() => import("./pages/CountryLanding"));
const PillarExternalDirection = lazy(() => import("./pages/PillarExternalDirection"));
import BookingModal from "./components/BookingModal";
import ScrollToTop from "./components/ScrollToTop";
import { countryLandings } from "./data/countryLandings";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Narwhal",
  url: "https://narwhalhub.com",
  description: "Dirección de Negocios B2B as a Service: dirigimos el frente comercial completo (prospección, contenido, SEO, GEO, AEO y datos) bajo una sola dirección.",
  sameAs: ["https://www.linkedin.com/company/narwhalhubb"],
  areaServed: ["Argentina", "Chile", "México", "Colombia", "Uruguay", "Perú", "España", "Ecuador", "Costa Rica", "Panamá"],
};

const SITE_URL = "https://narwhalhub.com";
const siteNavigationSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "Narwhal — Navegación principal",
  itemListElement: [
    { name: "Servicios", url: `${SITE_URL}/servicios` },
    { name: "Dirección Comercial Externa", url: `${SITE_URL}/direccion-comercial-externa` },
    { name: "Nosotros", url: `${SITE_URL}/nosotros` },
    { name: "Blog", url: `${SITE_URL}/blog` },
    { name: "Glosario", url: `${SITE_URL}/glosario` },
    { name: "Preguntas frecuentes", url: `${SITE_URL}/faq` },
    { name: "Descargables", url: `${SITE_URL}/descargables` },
    { name: "Contacto", url: `${SITE_URL}/#contacto` },
  ].map((it, i) => ({ "@type": "SiteNavigationElement", position: i + 1, name: it.name, url: it.url })),
};

function App() {
  return (
    <div className="App">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(siteNavigationSchema) }} />
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<div style={{ minHeight: "100vh", background: "#0a0e12" }} aria-hidden="true" />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/servicios" element={<Services />} />
            <Route path="/servicios/:slug" element={<Services />} />
            <Route path="/nosotros" element={<Nosotros />} />
            <Route path="/casos/:slug" element={<CaseStudy />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/glosario" element={<Glosario />} />
            <Route path="/glosario/:slug" element={<GlossaryTerm />} />
            <Route path="/descargables" element={<Descargables />} />
            <Route path="/direccion-comercial-externa" element={<PillarExternalDirection />} />
            {countryLandings.map((c) => (
              <Route key={c.slug} path={`/${c.slug}`} element={<CountryLanding slug={c.slug} />} />
            ))}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </Suspense>
        </BrowserRouter>
        <BookingModal />
        <Toaster />
      </LanguageProvider>
    </div>
  );
}

export default App;
